import { configureStore } from '@reduxjs/toolkit';
import eventsReducer from './events/eventsReducer';
import calendarReducer from './calendar/calendarReducer';
import appointmentReducer from './appointment/appointmentReducer';

const store = configureStore({
  reducer: {
    events: eventsReducer,
    calendar: calendarReducer,
    appointment: appointmentReducer,
  },
});

export default store;
